module.exports = __webpack_public_path__ + "img/smile5.1.bde7f70e.svg";